import React from 'react'
import HideWrap from '../comp/hideWrap'

const ConditionalHideWrap = ({
  name,
  title,
  syncStatus,
  status,
  view,
  hideSection,
  condition,
  children,
  isSection,
  isHealthRisk,
  isLowlevelMetrics,
  isIndividuals,
  isKeyWins
}) => {
  if (!condition) {
    return null
  }

  return (
    <HideWrap
      name={name}
      title={title}
      syncStatus={syncStatus}
      status={status}
      view={view}
      isSection={isSection}
      isHealthRisk={isHealthRisk}
      isLowlevelMetrics={isLowlevelMetrics}
      isIndividuals={isIndividuals}
      isKeyWins={isKeyWins}
    >
      {children}
    </HideWrap>
  )
}

export default ConditionalHideWrap
